export default __webpack_public_path__ + "static/media/cost-effective.ef5af584.svg";